export default __webpack_public_path__ + "static/media/stepper-tick.54a97675.svg";